import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

class Availability extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    let imagealt = "image";

    return (
      <div className="select-availability-area pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center---">
                <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">
                  Key Usability Facts
                </h6>
                <h1 className="section-title">Technical Specifications</h1>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__select-availability-table-wrap">
                <div className="ltn__select-availability-table d-none d-md-block">
                  <ul className="ltn__select-availability-table-head">
                    <li>Main Parameters</li>
                    <li>-</li>
                    <li>Environment</li>
                    <li>- </li>
                    <li>Mechanical</li>
                    <li>-</li>
                  </ul>
                  <ul className="ltn__select-availability-table-row">
                    <li className="tower-name">Battery Type</li>
                    <li>LiFePO4</li>
                    <li>Protection Rating</li>
                    <li>IP21</li>
                    <li>Weight</li>
                    <li>
                      <a
                      //   href="product-details.html"
                      >
                        50kg
                      </a>
                    </li>
                  </ul>
                  <ul className="ltn__select-availability-table-row">
                    <li className="tower-name">Capacity</li>
                    <li>100 AH</li>
                    <li>Altitude Limit</li>
                    <li> 2000 m</li>
                    <li>Size</li>
                    <li>
                      <a
                      //   href="product-details.html"
                      >
                        580 x 520 x 190 mm
                      </a>
                    </li>
                  </ul>
                  <ul className="ltn__select-availability-table-row">
                    <li className="tower-name">Voltage</li>
                    <li>51.2 volts</li>
                    <li>Storage Temperature</li>
                    <li>0°C to 40°C </li>
                    <li>Installation</li>
                    <li>
                      <a
                      //   href="product-details.html"
                      >
                        Wall Mounted and Table Top
                      </a>
                    </li>
                  </ul>
                  <ul className="ltn__select-availability-table-row">
                    <li className="tower-name">Operating Voltage Range</li>
                    <li>43.2V to 57.6V</li>
                    <li>Humidity Tolerance</li>
                    <li>5% to 95% </li>
                    <li>Recommended</li>
                    <li>
                      <a
                      //   href="product-details.html"
                      >
                        50 Amps
                      </a>
                    </li>
                  </ul>
                  <ul className="ltn__select-availability-table-row">
                    <li className="tower-name">Energy Storage</li>
                    <li>5.12 kWh</li>
                    <li>Operating Temperature</li>
                    <li>- 10°C to 50°C </li>
                    <li>Maximum</li>
                    <li>
                      <a
                      //   href="product-details.html"
                      >
                        100 Amps
                      </a>
                    </li>
                  </ul>
                  <ul className="ltn__select-availability-table-row">
                    <li className="tower-name">Usable Energy</li>
                    <li>4.6 kWh</li>
                    <li>Connectivity</li>
                    <li>Wi-Fi ( for cloud ) CAN and RS485 ( for inverter ) </li>
                    <li>Recommended Battery Usages</li>
                    <li>
                      <a
                      //   href="product-details.html"
                      >
                        Discharge Up to 90%
                      </a>
                    </li>
                  </ul>
                  <ul className="ltn__select-availability-table-row">
                    <li className="tower-name">Display</li>
                    <li>LCD Screen</li>
                    <li>Warranty</li>
                    <li>5 Years </li>
                    <li>-</li>
                    <li>
                      <a
                      //   href="product-details.html"
                      >
                        -
                      </a>
                    </li>
                  </ul>
                  <ul className="ltn__select-availability-table-row">
                    <li className="tower-name">Battery Life</li>
                    <li>6000 @ 0.5C ( Temp 25°C, EOL 70% )</li>
                    <li>Safety Standards</li>
                    <li>UN38.3 Certified</li>
                    <li>-</li>
                    <li>
                      <a
                      //   href="product-details.html"
                      >
                        -
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="ltn__select-availability-table-responsive d-md-none">
                  <ul className="ltn__select-availability-table-row-responsive-item">
                    <li>
                      <span>Main Parameters</span>
                      <span className="tower-name">-</span>
                    </li>
                    <li>
                      <span>Battery Type</span> <span>LiFePO4</span>
                    </li>
                    <li>
                      <span>Capacity</span> <span>100 AH</span>
                    </li>
                    <li>
                      <span>Voltage</span> <span>51.2 volts</span>
                    </li>
                    <li>
                      <span>Rent Price</span> <span>$3,500</span>
                    </li>
                    <li>
                      <span>Details</span>{" "}
                      <span>
                        <a
                        // href="product-details.html"
                        >
                          + Available
                        </a>
                      </span>
                    </li>
                  </ul>
                  <ul className="ltn__select-availability-table-row-responsive-item">
                    <li>
                      <span>Residence</span>{" "}
                      <span className="tower-name">Tower Name</span>
                    </li>
                    <li>
                      <span>Bedrooms</span> <span>3</span>
                    </li>
                    <li>
                      <span>Bathroom</span> <span>3</span>
                    </li>
                    <li>
                      <span>SQ.FT</span> <span>1,200</span>
                    </li>
                    <li>
                      <span>Rent Price</span> <span>$3,500</span>
                    </li>
                    <li>
                      <span>Details</span>{" "}
                      <span>
                        <a
                        // href="product-details.html"
                        >
                          + Available
                        </a>
                      </span>
                    </li>
                  </ul>
                  <ul className="ltn__select-availability-table-row-responsive-item">
                    <li>
                      <span>Residence</span>{" "}
                      <span className="tower-name">Tower Name</span>
                    </li>
                    <li>
                      <span>Bedrooms</span> <span>3</span>
                    </li>
                    <li>
                      <span>Bathroom</span> <span>3</span>
                    </li>
                    <li>
                      <span>SQ.FT</span> <span>1,200</span>
                    </li>
                    <li>
                      <span>Rent Price</span> <span>$3,500</span>
                    </li>
                    <li>
                      <span>Details</span>{" "}
                      <span>
                        <a
                        // href="product-details.html"
                        >
                          + Available
                        </a>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Availability;
